<template>
  <div class="container">

    <el-collapse v-model="menu" accordion @change="onFinanceChange">

      <el-collapse-item v-if="canAccess('finance')" name="settings" title="Settings">
        <h2>Finance Settings</h2>
        <el-row :gutter="24">

          <!-- Invoicing card hidden as part of XOL-356 (invoicing being rebuilt as its own
               epic). v-if="false" keeps the select-sharer / check-box refs so lint stays clean.
               Was: <el-col :span="24"> -->
          <el-col v-if="false" :span="24">
            <el-card>
              <template #header><div class="clearfix">
                <h3>Invoicing</h3>
              </div></template>
              <el-form>
                Select Sharer: <select-sharer v-model="telcoId" />

                <el-row  v-for="(inv, index) in settings.invoicing" :key="inv.id" :gutter="8">

                <el-col :span="8">
                  <check-box v-if="telcoId" v-model="inv.send" :disabled="!canEdit">{{inv.type}}</check-box>
                </el-col>
<!--
                <el-col :span="10">
                <el-form-item>
                  <el-cascader
                     :ref="'casc' + inv.id"
                     v-if="inv.send"
                     :props="{expandTrigger: 'hover'}"
                     v-model="settings.invoicing[index].timing"
                     :options="options"
                      :disabled="!canEdit">
                   </el-cascader>
                   <span v-else>
                     &nbsp;
                   </span>
                 </el-form-item>
                </el-col>
-->
                 <el-col :span="6" align="right">
                   <el-form-item>    <!-- @click="inv.callback"  -->
                     <el-button icon="fa fa-clock" v-if="inv.send" :type="inv.color" :disabled="!telcoId" @click="inv.callback">Run Now</el-button>
                   </el-form-item>
                </el-col>
              </el-row>

              <check-box label="e-Mail" label-width="12rem" v-model="settings.sendPDF" :disabled="true">Send PDF to Recipient</check-box>

              </el-form>
            </el-card>
          </el-col>

          <el-col :span="24">
            <br />
            <el-card>
              <template #header><div class="clearfix">
                <h3>Settings</h3>
              </div></template>
              <el-row>
                <el-form :props="settings" label-width="10rem">
                  <el-form-item label="Tax Name">
                    <el-input v-model="settings.taxName" :disabled="!canEdit" />
                  </el-form-item>
                  <el-form-item label="Tax Rate">
                    <el-input type="number" v-model="settings.taxRate" :disabled="!canEdit">
                      <template #append><span>%</span></template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="Tax Number">
                    <el-input v-model="settings.taxNumber" :disabled="!canEdit" />
                  </el-form-item>
                  <el-form-item label="Standard Tems">
                      <el-input type="number" v-model="settings.terms" :disabled="!canEdit">
                        <template #append><span>days</span></template>
                      </el-input>
                  </el-form-item>

                </el-form>
              </el-row>
            </el-card>
          </el-col>

        </el-row>

      </el-collapse-item>

      <!-- Agreements section hidden as part of XOL-65 (was v-if="canAccess('finance|management')") -->
      <el-collapse-item v-if="false" name="table" title="Agreements">

          <agreements-table />

      </el-collapse-item>

      <el-collapse-item v-if="canAccess('finance|management')" name="audit" title="Billing Audit">

          <licensee-audit />

      </el-collapse-item>

      <!-- Super-only (Carlos, 2026-07-15): bulk rate changes touch many sites'
           money in one action — restrict the tool to super administrators. This
           gates UI visibility; the /licensees/search and bulk-rate endpoints
           stay manager-gated server-side (API-side tightening is a separate
           providence change if wanted). -->
      <el-collapse-item v-if="isSuper()" name="bulk" title="Bulk licensee rate change">

          <bulk-rate-change />

      </el-collapse-item>

      <el-collapse-item name="rates" title="Rate Tables">

        <el-tabs type="card">
          <el-tab-pane label="Sharers" lazy>
            <rates-table  />
          </el-tab-pane>

          <el-tab-pane label="Tenancy" lazy>
            <rates-table view="tenancy" />
          </el-tab-pane>

          <el-tab-pane label="Utility" lazy>
            <rates-table view="utility" />
          </el-tab-pane>

        </el-tabs>

      </el-collapse-item>

      <!-- Agreements Builder hidden as part of XOL-65 (was v-if="canAccess('finance')") -->
      <el-collapse-item v-if="false" name="builder" title="Agreements Builder">

          <agreements-builder />

      </el-collapse-item>

    </el-collapse>



  </div>
</template>

<script>

import axios from '@/lib/axiosClient'

import {settings} from '@/components/Data'

import { FINANCE_SLUG_TO_INTERNAL, FINANCE_INTERNAL_TO_SLUG } from '@/lib/settingsSlugs'

import PostMixins from '@/mixins/PostMixins'
import NumberMixins from '@/mixins/NumberMixins'

import AgreementsTable from '@/components/finance/rates/AgreementsTable'
import RatesTable from '@/components/finance/rates/RatesTable'
import SelectSharer from '@/components/atoms/selects/SelectSharer'

import AgreementsBuilder from '@/components/settings/AgreementsBuilder'
import LicenseeAudit from '@/components/finance/audit/LicenseeAudit'
import BulkRateChange from '@/components/settings/BulkRateChange'

export default {
  mixins: [PostMixins, NumberMixins],

  components: {
    AgreementsBuilder,
    AgreementsTable,
    BulkRateChange,
    LicenseeAudit,
    SelectSharer,
    RatesTable
  },

  methods: {
    runSharerInvoices () {
      console.log('telcoId', this.telcoId)

      if (this.telcoId) {
        // XOL-121: wrap with getEndpoint so the request hits the API host
        // (PostMixins.send passes the URL straight to axios; without the
        // wrap it resolves against the page origin and 404s). Argument
        // order also fixed — `item` is the string label, successCallback
        // is the function. Previously the two were swapped, which would
        // TypeError on any 200 response. `putNoRetry` short-circuits the
        // global axios-retry on 5xx so one click is one PUT, not four —
        // these invoice routes have a known downstream 500 (XOL-124) and
        // retrying floods the API log without changing user-visible UX.
        this.send(this, this.getEndpoint('/invoice/sharers/' + this.telcoId), null, 'Sharer Invoice', this.success, this.fail, this.putNoRetry)
      }

    },

    runAdvanceInvoices () {
      console.log('telcoId', this.telcoId)

      if (this.telcoId) {
        this.send(this, this.getEndpoint('/invoice/advance/' + this.telcoId), null, 'Advance Invoice', this.success, this.fail, this.putNoRetry)
      }

    },

    runUtilityInvoices () {
      console.log('telcoId', this.telcoId)

      if (this.telcoId) {
        this.send(this, this.getEndpoint('/invoice/utility/' + this.telcoId), null, 'Utility Invoice', this.success, this.fail, this.putNoRetry)
      }

    },

    putNoRetry (url, data) {
      return axios.put(url, data, { 'axios-retry': { retries: 0 } })
    },

    success (response) {
      this.$alert('Invoice Job created, the invoices will be scheduled for creation during the early hours of the morning.')
    },

    fail (response) {
      this.$alert ('Failed')
    },

    onFinanceChange (name) {
      // accordion → name is a string ('' when fully collapsed)
      var slug = FINANCE_INTERNAL_TO_SLUG[name]
      // NavigationDuplicated guard — also handles '' → undefined (fully collapsed → /settings/finance)
      if (this.$route.params.financeTab === slug) return
      this.$router.push({ params: { settingTab: 'finance', financeTab: slug, drawerPath: undefined }, query: this.$route.query })
    }

  },

  watch: {
    '$route': {
      handler: function (route) {
        var slug = route.params.financeTab
        this.menu = FINANCE_SLUG_TO_INTERNAL[slug] || (this.canAccess('admin') ? 'rates' : 'settings')
      },
      immediate: false
    }
  },

  data () {
    var slug = this.$route.params.financeTab
    return {
      menu: FINANCE_SLUG_TO_INTERNAL[slug] || (this.canAccess('admin') ? 'rates' : 'settings'),
      canEdit: this.isManager('finance'),
      telcoId: null,
      timing: [],
      settings: {
        taxName: settings.taxName,
        taxRate: settings.taxRate,
        taxNo: '',
        terms: 30,
        sendPDF: false,
        invoicing: [
          {id: 1, type: 'Sharing Invoice', color: 'success', send: true, timing: [], callback: this.runSharerInvoices},
          {id: 2, type: 'Utility Advance Invoice', color: 'primary', send: true, timing: [], callback: this.runAdvanceInvoices},
          {id: 3, type: 'Utility Sharing Invoice', color: 'warning', send: true, timing: [], callback: this.runUtilityInvoices}
        ]
      },
      options: [{
        value: 'exact',
        label: 'Exact Day',
        children: [
        ]
      }, {
        value: 'first',
        label: 'First',
        children: [
          {value: 'mon', label: 'Monday'},
          {value: 'tue', label: 'Tuesday'},
          {value: 'wed', label: 'Wednesday'},
          {value: 'thu', label: 'Thursday'},
          {value: 'fri', label: 'Friday'},
          {value: 'sat', label: 'Satday'},
          {value: 'sun', label: 'Sunday'}
        ]
      }, {
        value: 'last',
        label: 'Last',
        children: [
          {value: 'mon', label: 'Monday'},
          {value: 'tue', label: 'Tuesday'},
          {value: 'wed', label: 'Wednesday'},
          {value: 'thu', label: 'Thursday'},
          {value: 'fri', label: 'Friday'},
          {value: 'sat', label: 'Satday'},
          {value: 'sun', label: 'Sunday'}
        ]
      }]
    }
  }, // data
  created () {
    let days = this.options[0].children

    for (let i = 0; i < 30; i++) {
      days.push({value: '' + (i + 1), label: this.addSuffix(i + 1) + ' of the month'})
    }
  }
}
</script>
